var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checked-tag"},[(_vm.isPass)?_c('img',{staticClass:"img",attrs:{"src":require("@/assets/travelAgency/ic_pass.png")}}):_c('img',{staticClass:"img",attrs:{"src":require("@/assets/travelAgency/ic_nopass.png")}}),_c('span',{class:_vm.isPass ? 'txt' : 'txt orangecolor'},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }